import clsx from 'clsx';
import { Reviews as ReviewsProps, SanityKeyed } from 'types/studio/studio';
import { navigationClickEvent } from 'analytics/events/studio';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import { CustomPortableText } from 'shared/studio/PortableText';
import { Container, Typography } from '@ag1/ui';
import styles from './styles.module.scss';
import ReviewsHeading from './ReviewsHeading/ReviewsHeading';
import ReviewsContent from './ReviewsContent/ReviewsContent';
import { useReviewsSlider } from './hooks/useReviewsSlider';
import { CommonSectionProps } from '../types';

const Reviews = ({
  _key: key,
  _type: sectionType,
  headline,
  subtitle,
  items,
  theme,
  addSlider,
  footnote,
  padding
}: SanityKeyed<ReviewsProps> & CommonSectionProps) => {
  const slider = useReviewsSlider({
    itemsLength: items.length,
    addSlider
  });

  const sendNavigationEvent = (direction: 'prev' | 'next') => {
    navigationClickEvent({
      clickText: direction,
      header: headline,
      location: sectionType,
      navigationType: 'carousel'
    });
  };

  return (
    <Container narrow id={key}>
      <article className={clsx(styles.root, getSectionPaddingClasses(styles, padding))}>
        <ReviewsHeading
          addSlider={addSlider}
          headline={headline}
          subtitle={subtitle}
          sectionType={sectionType}
          theme={theme}
          onScrollNext={() => {
            if (slider.scrollNext) {
              slider.scrollNext();
              sendNavigationEvent('next');
            }
          }}
          onScrollPrev={() => {
            if (slider.scrollPrev) {
              slider.scrollPrev();
              sendNavigationEvent('prev');
            }
          }}
          sliderActive={slider.active}
        />
        <div className={addSlider ? styles.slider : ''}>
          <ReviewsContent
            ref={slider.ref}
            items={items}
            sliderActive={slider.active}
            theme={theme}
          />
        </div>
        {footnote && (
          <Typography
            component="p"
            variant="portalText"
            size="2"
            noPadding
            className={styles.footnote}>
            <CustomPortableText value={footnote} />
          </Typography>
        )}
      </article>
    </Container>
  );
};

export default Reviews;
